// Constants and helpers shared by App.vue and the wallet / mint mixins.
export const WEBHOOK_URL = 'https://ta2f7ylhwu46yoen7xk2pvueee0qtjjt.lambda-url.us-west-2.on.aws/';
export const TOKEN_IMAGE_URL = 'https://millionbithomepage.com/static/favicon-32x32.png';
export const BASE_CHAIN_ID = '0x2105'; // Base Mainnet
export const BASE_RPC_URL = 'https://mainnet.base.org';
// For wallets that don't know Base yet (wallet_addEthereumChain).
export const BASE_CHAIN_PARAMS = {
  chainId: BASE_CHAIN_ID,
  chainName: 'Base',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: [BASE_RPC_URL],
  blockExplorerUrls: ['https://basescan.org'],
};
export const LOCAL_STORAGE_KEY_REFERRAL = 'REF_CODE';
export const BASENAME_L2_RESOLVER_ADDRESS = '0xC6d566A56A1aFf6508b41f6c90ff131615583BCD';
export const UNISWAP_ROUTER_V3 = '0x2626664c2603336E57B271c5C0b26F421741e481';
export const UNISWAP_QUOTER_V3 = '0x3d4e44Eb1374240CE5F1B871ab261CD16335B76a'; //'0x3d4e44Eb1374240CE5F1B871ab261CD16335B76a';
export const WETH_ADDRESS = "0x4200000000000000000000000000000000000006"; // WETH on Ethereum mainnet
export const FEE_TIER = Number(10000); // Uniswap V3 pool fee (3000 = 0.3%)

export const DO_LOG = process.env.NODE_ENV !== 'production';
export function log() {
  if(DO_LOG) {
    console.log.apply(console, arguments);
  }
}

export function trackEvent(t) {
  try {
    if (window.umami) {
      window.umami.track(t);
    }
  } catch(e) {
    console.error('Failed to track event', e);
  }
}

